import { LedgerConnectionApiFactory } from '@mynt/backoffice-api-spec/ledger-platform'
import Axios from 'api/axios'
import config from 'config'
import { mapLedgerConnectionResponse } from './mappers'

const ledgerConnectionApi = LedgerConnectionApiFactory(undefined, config.boBaseUrl, Axios)

export const getLedgerConnection = (customerId: string) =>
  ledgerConnectionApi.getLedgerConnection(customerId).then(({ data }) => mapLedgerConnectionResponse(data))

export const disconnectLedger = (customerId: string) => ledgerConnectionApi.disconnectLedgerConnection(customerId).then(() => undefined)
